import Image from 'next/image';

import { Box, Heading, Paragraph, ProgressBar } from '@zillow/constellation-10';

import aiDrafting from '../../../../../assets/ai-drafting.svg';

const ILLUSTRATION_BOX_PX = 120;
const ILLUSTRATION_PX = 108;
/** ProgressBar has no indeterminate mode and generation length is unknown, so this mirrors the Figma value. */
const DRAFTING_PROGRESS_VALUE = 40;

const AiDraftingState = () => (
  <Box
    data-testid="AiDraftingState"
    css={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '500' }}
  >
    <Box
      css={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 'default',
        padding: 'default',
        maxWidth: '584px',
        width: '100%',
      }}
    >
      <Box
        css={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: `${ILLUSTRATION_BOX_PX}px`,
          height: `${ILLUSTRATION_BOX_PX}px`,
        }}
      >
        <Image src={aiDrafting} alt="" width={ILLUSTRATION_PX} height={ILLUSTRATION_PX} />
      </Box>
      <Box css={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 'default', width: '100%' }}>
        <Box
          css={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 'tightest',
            textAlign: 'center',
            width: '100%',
          }}
        >
          <Heading level={2} textStyle="heading-xs">
            We’re working on your property description
          </Heading>
          <Paragraph textStyle="body-sm">
            We’re using your photos, notes, and property data to draft your property description. Check back in a couple
            of minutes, and it should be ready for review.
          </Paragraph>
        </Box>
        <ProgressBar aria-label="Drafting your property description" value={DRAFTING_PROGRESS_VALUE} />
      </Box>
    </Box>
  </Box>
);

export default AiDraftingState;
